window.addEventListener("load", (event) => {

    if (window.innerWidth <= 600) {
        let pricesArray = $('#minMax').val().split(',').map(Number);

        $(window).bind("pageshow", function() {
            $("html, body").animate({
                scrollTop: 0
            }, 100);
        });

        $('.dropdown-item').click(function (){
            $('.dropdown-item').removeClass('chose-item');
            setCookie('chose', 1);
            $(this).addClass('chose-item');
        })

        let sortTypeCook = getCookie('sortType');
        if( sortTypeCook === 'list'){
            sortList();
        }
        else {
            sortGrid()
        }

        function sortList() {
            setCookie('sortType', 'list');
            $('.btn-control-mobile').addClass('btn-control-list-mobile');
            $('.btn-control-mobile').removeClass('btn-control-grid-mobile');
            $('.product-inner').addClass('row').removeClass('col-12');
            $('.product-img').addClass('col-5').removeClass('col-12');
            $('.basicMainCol').addClass('col-12').removeClass('col-6');
            $('.productRow').addClass('col-7').removeClass('colum');
            $('.price-box').addClass('text-life').removeClass('text-center');
            $('.stAddToCartForm').addClass('listForm');
            /*	$('.product-buy').addClass('row');*/
            $('.price-box').addClass('col-12');
            $('.product-img-a').addClass('productImgStyle');
            $('.productRowGroup').removeClass('productRowName');
            $('.product').removeClass('productGrid');
            $('.like-in-list').show();
            $('.wishlist-link').hide();
            /*	$('.stAddToCart ').html('<i class="fas fa-shopping-cart icon-orange-outline"></i>').addClass('btn-list').removeClass('col-12');*/
            $('.product-border').css("border-right", "none");
            setCookie('sort', 'line')
        }

        function sortGrid() {
            setCookie('sortType', 'grid');
            $('.btn-control-mobile').addClass('btn-control-grid-mobile').removeClass('btn-control-list-mobile');
            $('.product-inner').removeClass('row').addClass('col-12');
            $('.product-img').removeClass('col-5');
            $('.basicMainCol').removeClass('col-12').addClass('col-6');
            $('.productRow').removeClass('col-7').addClass('colum');
            $('.price-box').removeClass('text-life','col-12').addClass('text-center');
            $('.stAddToCartForm').removeClass('col-3 btn-group-tem listForm');
            $('.product-buy').removeClass('row');
            /*$('.price-box').removeClass('col-12');*/
            $('.product-img-a').removeClass('productImgStyle');
            $('.productRowGroup').addClass('productRowName');
            $('.product').addClass('productGrid');
            $('.like-in-list').hide();
            $('.wishlist-link').show();
            /*$('.stAddToCart ').html('<i class="fas fa-shopping-cart icon-orange-outline"></i>В кошик').removeClass('btn-list').addClass('col-12');*/
            $('.product-border').css("border-right", "1px solid silver");
        }

        $('.btn-control-mobile').click( function (){
            let sortType = getCookie('sortType');
            if( sortType === 'list'){
                sortGrid();
            }
            else {
                sortList()
            }
        });

        $('#category-filter').scroll(function(){
            var scrollPos = $('#category-filter').scrollTop();
            if(scrollPos > 150){
                $('.filter-used').addClass('filter-used-fix');
            }else{
                $('.filter-used').removeClass('filter-used-fix');
            }
        });

        $('#filter-section-kolektsiia').on('click', function () {
            if ($("#searchCollection").hasClass('d-none')) {
                $("#searchCollection").removeClass('d-none');
            }
        });


        $(document).ready(function (){
            let check_category = $('.block_category').data("check-category");

            $(".li-t-typ-tovaru-i-"+check_category+"").addClass('trues');
        });

        let $rangePrices = $(".priceFilter");

        if (pricesArray.length > 0) {
            $rangePrices.ionRangeSlider({
                skin: "big",
                type: "double",
                grid: true,
                values: pricesArray,
            });
        } else {
            console.log($rangePrices)
            $rangePrices.ionRangeSlider({
                skin: "big",
                min:pricesArray[0],
                max:pricesArray[0],
                hide_min_max: true
            });
        }

        $('.popular').each(function () {
            let col = $(this).data('colection');
            let last = col.split(":").pop();
            $(this).find('.colect_name').text(last);

        });

        let opnBox= $('.show_all_text').data('open');
        let closedBox= $('.show_all_text').data('closed');
        $('.show_all_text').click(function () {
            $('html, body').animate({
                scrollTop: parseInt($(".description_container").offset().top)
            }, 1000);
            // let descrLength = $('.text_description').text().length;
            // let statOpen = $(this).data('show');
            // if (statOpen === false && descrLength > 1000){
            // 	$('.text_description').addClass('openBox');
            // 	$(this).html(closedBox);
            // 	$(this).data('show', true);
            // }else{
            // 	$('.text_description').removeClass('openBox');
            // 	$(this).html(opnBox);
            // 	$(this).data('show', false);
            // 	$("html, body").animate({ scrollTop: 0 }, "slow");
            // }
        });

        /* JS products  */
        let selectGrid = getCookie('gridType');
        if (selectGrid === 'grid') {

            $('.btn-control').removeClass('grid-SmallGroup-wrapper').addClass('grid-group-wrapper');
            $('.btn-control-grid').addClass('active');
            $('.btn-control-smallGrid').removeClass('active');
            $('.IdProductCatalog').removeClass('col-lg-4 col-xl-4').addClass('col-lg-3 col-xl-3');

        } else {

            $('.btn-control').removeClass('grid-group-wrapper').addClass('grid-SmallGroup-wrapper');
            $('.btn-control-smallGrid').addClass('active');
            $('.btn-control-grid').removeClass('active');
            $('.IdProductCatalog').removeClass('col-lg-3 col-xl-3').addClass('col-lg-4 col-xl-4');

        }

        $('.btn-control').click(function () {
            let gridType = $(this).data('ls');
            setCookie('gridType', gridType);

        });


        window.onpopstate = function () {
            document.location.reload();
        };

    } else {

        function swapGrid() {
            let selectGrid = getCookie('gridType');
            if (selectGrid === 'grid') {
                $('.btn-control').removeClass('grid-SmallGroup-wrapper').addClass('grid-group-wrapper');
                $('.btn-control-grid').addClass('active');
                $('.btn-control-smallGrid').removeClass('active');
                $('.IdProductCatalog').removeClass('col-lg-4 col-xl-4').addClass('col-lg-3 col-xl-3');

            } else {
                $('.btn-control').removeClass('grid-group-wrapper').addClass('grid-SmallGroup-wrapper');
                $('.btn-control-smallGrid').addClass('active');
                $('.btn-control-grid').removeClass('active');
                $('.IdProductCatalog').removeClass('col-lg-3 col-xl-3').addClass('col-lg-4 col-xl-4');
            }
        }

        $('body').on('submit', '.form-add-to-cart', function (e) {
            e.preventDefault();
            $('.modalCartTrigger').removeClass('not-link');
            $('#cart-overlay').show();
            $('#modalCart').modal();
            $.ajax({
                data: $(this).serialize(),
                type: "POST",
                url: '/ajax/add_to_cart',
                timeout: 20000,
                contentType: "application/x-www-form-urlencoded;charset=UTF-8",
                dataType: 'json',
                statusCode: {
                    200: function () {
                        $('#modalCartDataWrap').load(window.location.origin + ' #modalCartData', function (data) {
                            $('.count-products').html($('#count-products-total').html());
                            $('.nano').nanoScroller();
                            $('#cart-overlay').hide();
                            $('.shopping-cart-empty').removeClass('active');
                            $('.shopping-cart-full').addClass('active');
                            $('.count-products').removeClass('d-none');
                        });
                    }
                }
            });
            console.log('done')
        });

        let $rangePrices = $(".priceFilter");

        if (pricesArray.length > 0) {
            pricesArray.forEach(function(e, i) {
                if(i === 0 && e >= from) from = i;
                else if(pricesArray[i] >= from && pricesArray[i - 1] <= from) from = i;
                if(i === (pricesArray.length - 1) && e <= to) to = i;
                else if(e <= from && pricesArray[i - 1] >= to) to = i+1;
                if(e === to) to = i+1;
            })
            const config = {
                min: pricesArray[0],
                max: pricesArray[pricesArray.length - 1],
                from: from,
                to: to,
                skin: "big",
                type: "double",
                grid: true,
                values: pricesArray,
            }

            $rangePrices.ionRangeSlider(config);
        } else {
            $rangePrices.ionRangeSlider({
                skin: "big",
                min:pricesArray[0],
                max:pricesArray[0],
                hide_min_max: true
            });
        }

        $('.popular').each(function () {
            let col = $(this).data('colection');
            let last = col.split(":").pop();
            $(this).find('.colect_name').text(last);
        });

        let opnBox = $('.show_all_text').data('open');
        let closedBox = $('.show_all_text').data('closed');
        $('.show_all_text').click(function () {

            $('html, body').animate({
                scrollTop: parseInt($(".description_content").offset().top)
            }, 1000);

        });

        /* JS products  */
        $('.btn-control').click(function () {
            let gridType = $(this).data('ls');
            setCookie('gridType', gridType);

        });

        swapGrid();
        $('.dropdown-item').click(function () {
            swapGrid();
        });

        $('body').on('input', '.collection-search', function () {
            $(this).parents('.filter-section').find('.filter-checkbox-item').addClass('filter-item-hide');
            $(this).parents('.filter-section').find('.filter-checkbox-item:contains("' + $(this).val().toLowerCase() + '")').removeClass('filter-item-hide');
        });
    }
})